import emailjs from "@emailjs/browser";
import { APP_NAME } from "../config/brand";

function getEmailJsConfig() {
    return {
        serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID || "",
        templateId:
            process.env.REACT_APP_EMAILJS_PASSWORD_RESET_TEMPLATE_ID ||
            process.env.REACT_APP_EMAILJS_TEMPLATE_ID ||
            "",
        publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY || "",
    };
}

export function isPasswordResetEmailJsConfigured() {
    const { serviceId, templateId, publicKey } = getEmailJsConfig();
    return Boolean(serviceId && templateId && publicKey);
}

function roleLabel(accountType) {
    if (accountType === "Student") return "student portal";
    if (accountType === "Teacher") return "staff portal";
    if (accountType === "System") return "platform operator account";
    return "school director account";
}

/**
 * Send password reset link via EmailJS (browser — same approach as school registration alerts).
 * @param {{ toEmail: string, userName?: string, resetUrl: string, accountType?: string }} delivery
 */
export async function sendPasswordResetViaEmailJs(delivery) {
    const { serviceId, templateId, publicKey } = getEmailJsConfig();

    if (!serviceId || !templateId || !publicKey) {
        console.warn("EmailJS password reset skipped: missing env configuration.");
        return { ok: false, skipped: true, reason: "EmailJS not configured" };
    }

    const toEmail = String(delivery?.toEmail || "").trim();
    const resetUrl = String(delivery?.resetUrl || "").trim();
    if (!toEmail || !resetUrl) {
        return { ok: false, skipped: true, reason: "Missing recipient or reset URL" };
    }

    const accountType = String(delivery?.accountType || "");
    const userName = String(delivery?.userName || "").trim();
    const label = roleLabel(accountType);

    const templateParams = {
        to_email: toEmail,
        user_name: userName,
        reset_url: resetUrl,
        account_type: accountType,
        app_name: APP_NAME,
        message:
            `${userName ? `Hello ${userName}, ` : ""}` +
            `reset your ${label} password on ${APP_NAME}. ` +
            `This link expires in 1 hour: ${resetUrl}`,
    };

    await emailjs.send(serviceId, templateId, templateParams, { publicKey });
    return { ok: true };
}
